<template>
    <a-card>
        <div id="instagram-wizard">
            <a-steps v-model="current" type="navigation" :style="stepStyle">
                <a-step :status="getStatus(0)" :title="$t('wp.agreement')" :disabled="current !== 0" />
                <!-- <a-step :status="getStatus(1)" :title="$t('wp.purchase')" :disabled="current !== 1" /> -->
                <a-step :status="getStatus(2)" title="Instagram Service Activation" :disabled="current !== 2" />
                <a-step :status="getStatus(3)" title="Authentication" :disabled="current !== 3" />
                <a-step :status="getStatus(4)" :title="$t('wp.ready')" :disabled="current !== 4" />
            </a-steps>

            <div class="d-flex justify-content-center">
                <div v-if="current === 0" class="step step0">
                    <Agreement @agree="agree" />
                </div>
                <!-- <div v-if="current === 1" class="step step1">
                    <Purchase :purchase-completed="purchaseCompleted" />
                </div> -->
                <div v-if="current === 2" class="step step2">
                    <Activation :activated="activationCompleted" />
                </div>
                <div v-if="current === 3" class="step step3">
                    <Authentication />
                </div>
                <div v-if="current === 4" class="step step4">
                    <IGStatusViewer />
                </div>
            </div>
        </div>
    </a-card>
</template>

<script>
import Agreement from "./Agreement";
import Purchase from "./Purchase";
import Activation from "./Activation";
import Authentication from "./Authentication";
import IGStatusViewer from "./IGStatusViewer";
import { mapMutations, mapState } from "vuex";
import CONFIG from "../../../../../../config/config";
import { sendSocketMessage } from "../../../../../../utils/socketStream";
import log2 from "../../../../../../utils/log2";

const log = log2("InstagramWizard");
const STATES = CONFIG.INSTAGRAM.STATES;
export default {
    name: "InstagramWizard",
    components: {
        Agreement,
        Purchase,
        Activation,
        Authentication,
        IGStatusViewer,
    },
    data() {
        return {
            current: 0,
            stepStyle: {
                marginBottom: "60px",
                boxShadow: "0px -1px 0 0 #e8e8e8 inset",
            },
            waiting: false,
            agreementAccepted: false,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            initialized: (state) => state.instagram.info.initialized,
            status: (state) => state.instagram.info.status,
            instagramPlan: (state) => state.site.currentPlans.find((cp) => cp.planType === "instagram"),
        }),
    },
    methods: {
        ...mapMutations({
            setInstagramInfo: "instagram/setInfo",
        }),
        getStatus(order) {
            if (order < this.current) return "finish";
            if (order === this.current) return "process";
            return "wait";
        },
        fetchInstagramStatus() {
            sendSocketMessage("user get-instagram-status", {
                siteId: this.site._id,
            });
        },
        goInstagramPlans() {
            this.$router.push({
                path: `/billing/plans/instagram`,
            });
        },
        agree() {
            this.agreementAccepted = true;
            this.current = 1;
            if (!this.instagramPlan) this.goInstagramPlans();
            localStorage.setItem("ig-agreement-accepted", "true");
        },
        activationCompleted() {
            this.current = 3;
        },
        purchaseCompleted() {
            this.current = 2;
        },
        reCalculateStep(newStatus) {
            newStatus = newStatus || this.status;
            const botState = newStatus.status;
            const isCompleted = botState === STATES.READY;
            const isAuthenticationStep = [
                STATES.AUTHENTICATING,
                STATES.AUTH_FAILED,
                STATES.CHALLENGE_REQUIRED,
            ].includes(botState);
            log("reCalculateStep", {
                newStatus,
                isCompleted,
                isAuthenticationStep,
                botState,
            });

            if (!newStatus.purchased) {
                if (localStorage.getItem("ig-agreement-accepted") === "true") {
                    this.current = 1;
                    if (!this.instagramPlan) this.goInstagramPlans();
                } else {
                    this.current = 0;
                }
            } else {
                this.agreementAccepted = true;

                if (isCompleted) {
                    this.current = 4;
                } else if (isAuthenticationStep) {
                    this.current = 3;
                } else {
                    this.current = 2;
                }
            }
        },
    },
    mounted() {
        log("mounted");
        this.fetchInstagramStatus();
        if (!this.status.purchased) {
            if (localStorage.getItem("ig-agreement-accepted") === "true") {
                this.current = 1;
                if (!this.instagramPlan) this.goInstagramPlans();
                this.agreementAccepted = true;
            } else {
                this.current = 0;
            }
        }
        this.reCalculateStep();
        this.timerId = setInterval(() => {
            this.fetchInstagramStatus();
        }, 3000);
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
    watch: {
        status(newStatus) {
            log("newStatus changed", newStatus);
            this.reCalculateStep(newStatus);
        },
    },
};
</script>

<style lang="scss">
#instagram-wizard {
    //border: 1px solid black;
    padding: 5px;

    .step {
        display: flex;
        justify-content: center;
        //border: 1px solid gray;

        h2,
        h4 {
            color: var(--info);
        }
    }

    .plans {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;

        span.ant-divider-inner-text {
            font-size: 12px !important;
            color: #935774 !important;
        }

        .plan {
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #aa4b6b;
            width: 300px;
            min-height: 679px;
            margin-left: 20px;

            .selectAgentCount {
                width: 200px;
                padding: 0 !important;
                margin: 0 !important;
                min-height: 34px;
            }

            .features {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;

                .feature {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin: 1px 5px;
                    padding: 2px;

                    i {
                        color: green;
                    }

                    span {
                        margin-left: 5px;
                    }
                }
            }

            .header {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                font-size: 20px;
                font-weight: 400;
                background: #aa4b6b; /* fallback for old browsers */
                background: -webkit-linear-gradient(
                    to bottom,
                    #3b8d99,
                    #6b6b83,
                    #aa4b6b
                ); /* Chrome 10-25, Safari 5.1-6 */
                background: linear-gradient(
                    to bottom,
                    #3b8d99,
                    #6b6b83,
                    #aa4b6b
                ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
                color: white;
                width: 100%;
            }

            .plan-price-details {
                padding: 0;
                font-size: 45px;
                line-height: 49px;
                font-weight: 400;
                font-family: "source-sans-pro", helvetica;
                color: #333;
                text-align: center;

                i {
                    font-weight: 600;
                    font-size: 16px;
                    font-style: normal;
                    font-family: myriad-pro;
                    line-height: 21px;
                }
            }

            .pricing-cycle-info {
                padding-bottom: 21px;
            }

            .amount {
                font-size: 45px;

                &:before {
                    content: "$";
                    font-size: 16px;
                    position: absolute;
                    font-weight: 400;
                    line-height: 21px;
                    margin-left: -10px;
                }
            }

            .amount.tl {
                &:before {
                    content: "₺";
                }
            }
        }

        .plan.new,
        .plan.old {
            min-height: 475px !important;
        }

        .plan.selected {
            border-right: 3px;
            border-bottom: 3px;
            box-shadow: #8c5a77 -9px 2px 9px 3px;
        }
    }
}

.md-select-menu,
.ant-message {
    z-index: 9999999999999999999 !important;
}
</style>
